import { call, put, takeEvery, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { getRevenueApi } from '../../api/revenueApi';
import {
  FETCH_REVENUE_REQUEST,
  FETCH_REVENUE_SUCCESS,
  FETCH_REVENUE_FAILURE,
} from '../constants/revenueConstants';

function* fetchRevenueSaga(action) {
  try {
    const { user } = yield select((state) => state.auth);
    const almataId = user?.almataPartner?.id || user?.id || user?._id;
    
    const params = {
      ...action.payload,
      almataId,
    };

    const response = yield call(getRevenueApi, params);
    
    yield put({
      type: FETCH_REVENUE_SUCCESS,
      payload: response,
    });
  } catch (error) {
    console.error('Revenue fetch error:', error);
    yield put({
      type: FETCH_REVENUE_FAILURE,
      payload: error.response?.data?.message || error.message || 'An error occurred',
    });
    toast.error(error.response?.data?.message || 'Failed to fetch revenue data');
  }
}

function* revenueSaga() {
  yield takeEvery(FETCH_REVENUE_REQUEST, fetchRevenueSaga);
}

export default revenueSaga;